<div class="card">
    <div class="flex flex-col gap-6 items-center w-full" *ngIf="ready">
        <div class="w-full">
            <button class="button-elevation p-2 rounded-full" (click)="goBackToPois()">Tutti i POI</button>
        </div>

        <div class="w-full shadow-medium p-4 rounded-3xl">
            <p class="text-2xl">POI</p>
            <app-dynamic-form
                #myForm
                [options]="form2Opts"
                [fields]="regConfig2"
                (resetData)="initializeForm()"
                (submit)="submit($event)">
            </app-dynamic-form>
        </div>

        @if (object) {
            <div class="w-full shadow-medium p-4 rounded-3xl">
                <p class="text-2xl mb-4">Missioni collegate</p>

                <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                    @for (mission of object.missions ?? []; track mission.id) {
                        <div class="flex flex-col rounded-2xl bg-white/10 hover:scale-105 transition-spring-500ms">
                            <div class="flex flex-col gap-2 p-4 h-full w-full hover:cursor-pointer" (click)="editMission(mission)">
                                <p class="font-bold text-2xl text-primary-500">
                                    {{ mission.name }}
                                </p>

                                <p class="w-full text-sm font-light">{{ mission.description }}</p>
                                <app-card-summary-singleline
                                    title="Punti"
                                    [value]="mission.pointsRedeem ? mission.pointsRedeem.toString() : '0' ">
                                </app-card-summary-singleline>
                                <app-card-summary-singleline
                                    title="Step"
                                    [value]="mission.steps ? mission.steps.length.toString() : '0' ">
                                </app-card-summary-singleline>
                                <app-card-summary-singleline
                                    title="Tipo sblocco"
                                    [value]="unlockTypeToString(mission.unlockType)">
                                </app-card-summary-singleline>
                            </div>

                            <div class="flex justify-end items-center p-2">
                                <button mat-icon-button style="color:red!important" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                        class="icon icon-tabler icons-tabler-outline icon-tabler-trash">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                        <path d="M4 7l16 0" />
                                        <path d="M10 11l0 6" />
                                        <path d="M14 11l0 6" />
                                        <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                        <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                                    </svg>
                                </button>

                                <mat-menu #menu="matMenu" backdropClass="bg-black/20">
                                    <div class="rounded-3xl bg-primary-950 p-4 flex flex-col gap-4" (click)="$event.stopPropagation()">
                                        <p class="text-primary-400">Vuoi procedere con l'eliminazione?</p>
                                        <div class="flex justify-center items-center gap-2">
                                            <button type="button" class="w-full bg-primary-500 text-black p-2 rounded-full">Annulla</button>
                                            <button
                                                type="button"
                                                class="w-full bg-red-500 text-white p-2 rounded-full"
                                                (click)="deleteMission(mission.id)">
                                                Elimina
                                            </button>
                                        </div>
                                    </div>
                                </mat-menu>
                            </div>
                        </div>
                    }

                    @if ((object.missions?.length ?? 0) === 0) {
                        <div class="md:col-span-2 xl:col-span-3 flex justify-center items-center">
                            <p>Nessuna missione collegata</p>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</div>
